module.exports = __webpack_public_path__ + "img/source04_4.abbf4677.png";